module.exports = __webpack_public_path__ + "img/160.b81b50ff.png";